import { useMutation, useQuery } from "@tanstack/react-query";
import { getApp } from "firebase/app";
import { doc, getDoc, getFirestore } from "firebase/firestore";
import { COURSE_CLASS_COLLECTION } from "src/constants/collectionsIds";

export default function useGetSession(params, options = {}) {
  return useQuery({
    queryKey: ["class-session", params],
    queryFn: async ({ queryKey }) => {
      let [, { id }] = queryKey;
      const app = getApp();
      const db = getFirestore(app);
      const sessionDoc = doc(db, `${COURSE_CLASS_COLLECTION}/${id}`);
      const sessionSnapshot = await getDoc(sessionDoc);

      if (!sessionSnapshot.exists()) {
        throw new Error("Session does not exist");
      }

      const session = sessionSnapshot.data();
      console.log(session);
      return {
        session,
      };
    },
    ...options,
  });
}
